import ImageCustom from '@/components/Image'
import { truncate } from '@/libs/functions'
import { BlogType } from '@/libs/types'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'
import { Col } from 'react-bootstrap'

interface CardOneProps {
    locale: string
    blog: BlogType

}

const CardOne: React.FC<CardOneProps> = ({ locale, blog }) => {
    const { title, description, thumb } = blog.attributes

    const thumbnail = thumb?.data?.attributes?.formats?.small?.url || thumb
    return (
        <div className="mb-4 mb-md-3 post col-md-4 col-12">
            <Link href={`/${locale}/news/${blog.attributes.slug.split(",").join("/")}`}
                className={clsx("h-100 d-block bg-white rounded text-decoration-none text-black")}
                passHref
            >
                {!!thumbnail && (
                    <div className="post__thumb__related rounded-top">
                        <ImageCustom src={thumbnail} fill alt={title}
                            className="object-fit-cover" />
                    </div>
                )}
                <div className="p-4 p-md-5">
                    <h3 className="mb-3">{title}</h3>
                    <p className="mb-0">{truncate(description, 200)}</p>
                </div>
            </Link>
        </div>
    )
}

export default CardOne